import React, { useState } from "react";
import { Grid, Paper, Typography, Box, TextField, Stack, Button, Switch, FormControlLabel } from "@mui/material";

function Card({ title, subtitle, children }) {
  return (
    <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: "1px solid var(--border)", bgcolor: "var(--branco)" }}>
      <Typography sx={{ fontWeight: 900, color: "var(--cise-text)" }}>{title}</Typography>
      {subtitle && <Typography sx={{ color: "var(--cise-text-muted)", fontSize: 13, mt: 0.3 }}>{subtitle}</Typography>}
      <Box sx={{ mt: 2 }}>{children}</Box>
    </Paper>
  );
}

export default function OrganizationTab() {
  const [form, setForm] = useState({
    unitName: "Cultura Inglesa de Sergipe",
    city: "Aracaju",
    phone: "(79) 0000-0000",
    email: "contato@cise.com.br",
    address: "Av. Exemplo, 123",
    workingHours: "Seg–Sex 08:00–20:00 | Sáb 08:00–12:00",
    slaMinutes: 10,
    allowAfterHours: false,
  });

  const onChange = (k) => (e) => setForm((p) => ({ ...p, [k]: e.target.value }));

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={7}>
        <Card title="Dados da unidade" subtitle="Informações públicas e operacionais">
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField label="Nome da unidade" value={form.unitName} onChange={onChange("unitName")} fullWidth size="small" />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField label="Cidade" value={form.city} onChange={onChange("city")} fullWidth size="small" />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField label="Telefone" value={form.phone} onChange={onChange("phone")} fullWidth size="small" />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField label="E-mail" value={form.email} onChange={onChange("email")} fullWidth size="small" />
            </Grid>
            <Grid item xs={12}>
              <TextField label="Endereço" value={form.address} onChange={onChange("address")} fullWidth size="small" />
            </Grid>
          </Grid>

          <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
            <Button
              variant="contained"
              sx={{ textTransform: "none", fontWeight: 900, bgcolor: "var(--cise-blue)", "&:hover": { bgcolor: "var(--cise-blue)" } }}
              onClick={() => alert("Salvar (futuro)")}
            >
              Salvar
            </Button>
          </Stack>
        </Card>
      </Grid>

      <Grid item xs={12} md={5}>
        <Card title="Regras da operação" subtitle="SLA, horário e comportamento do atendimento">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Horário de atendimento"
                value={form.workingHours}
                onChange={onChange("workingHours")}
                fullWidth
                size="small"
                helperText="Ex.: Seg–Sex 08:00–20:00 | Sáb 08:00–12:00"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="SLA máximo (minutos) sem resposta"
                value={form.slaMinutes}
                onChange={onChange("slaMinutes")}
                fullWidth
                size="small"
                type="number"
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={form.allowAfterHours}
                    onChange={(e) => setForm((p) => ({ ...p, allowAfterHours: e.target.checked }))}
                  />
                }
                label="Permitir atendimento fora do horário"
              />
              <Typography sx={{ color: "var(--cise-text-muted)", fontSize: 12.5 }}>
                Se desligado, automações e alertas respeitam o horário configurado.
              </Typography>
            </Grid>
          </Grid>

          <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
            <Button
              variant="contained"
              sx={{ textTransform: "none", fontWeight: 900, bgcolor: "var(--cise-blue)", "&:hover": { bgcolor: "var(--cise-blue)" } }}
              onClick={() => alert("Salvar (futuro)")}
            >
              Aplicar regras
            </Button>
          </Stack>
        </Card>
      </Grid>
    </Grid>
  );
}
